(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gq-studio"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.gqStudio) return;
  const body = document.body;
  if (!body || !body.hasAttribute('data-gq-theme')) return;
  window.gqStudio = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const controllers = new Map();
  const running = new Set();
  let enabled = body.dataset.gqMotionEnabled !== 'false';
  const canAnimate = element => enabled && !reduced.matches && element?.closest('[data-gq-section-motion]')?.dataset.gqSectionMotion !== 'false';
  const root = document.documentElement;
  const progress = document.createElement('div');
  progress.className = 'gq-scroll-progress';
  progress.setAttribute('aria-hidden', 'true');
  if (body.hasAttribute('data-gq-home')) body.append(progress);

  let frame = 0;
  const paint = () => {
    frame = 0;
    if (!canAnimate() || document.hidden) return;
    const height = Math.max(1, root.scrollHeight - window.innerHeight);
    progress.style.transform = `scaleX(${Math.min(1,Math.max(0,window.scrollY / height))})`;
    const hero = document.querySelector('[data-gq-hero]');
    if (!hero || !canAnimate(hero) || !fine.matches) return;
    const rect = hero.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
    const distance = Math.max(0, Math.min(1, -rect.top / rect.height));
    hero.style.setProperty('--gq-depth', `${(distance * 32).toFixed(2)}px`);
    hero.style.setProperty('--gq-scale', (1.04 + distance * .035).toFixed(3));
  };
  const queuePaint = () => { if (!frame && canAnimate()) frame = requestAnimationFrame(paint); };

  function sync() {
    enabled = body.dataset.gqMotionEnabled !== 'false';
    body.dataset.gqAnimate = String(canAnimate());
    running.forEach(animation => {
      if (!canAnimate(animation.effect?.target)) {
        animation.cancel();
        running.delete(animation);
      }
    });
    document.querySelectorAll('[data-gq-hero]').forEach(hero => {
      if (!canAnimate(hero) || !fine.matches) {
        ['--gq-depth','--gq-scale'].forEach(property => hero.style.removeProperty(property));
      }
    });
    if (!canAnimate()) {
      progress.style.transform = 'scaleX(0)';
    } else queuePaint();
  }

  function mount(scope) {
    if (controllers.has(scope)) return;
    const controller = new AbortController();
    const cleanups = [];
    controllers.set(scope, {controller, cleanups});
    const on = (target, type, listener, options = {}) => target.addEventListener(type, listener, {...options, signal: controller.signal});

    if ('IntersectionObserver' in window) {
      const reveal = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          reveal.unobserve(entry.target);
          if (!canAnimate(entry.target) || typeof entry.target.animate !== 'function') return;
          const stagger = Number(entry.target.style.getPropertyValue('--gq-stagger')) || 0;
          const animation = entry.target.animate([
            {opacity: .1, transform: 'translate3d(0,24px,0)'},
            {opacity: 1, transform: 'translate3d(0,0,0)'}
          ], {duration: 700, delay: Math.min(stagger * 55,165), easing: 'cubic-bezier(.2,.75,.25,1)'});
          running.add(animation);
          animation.finished.then(() => running.delete(animation)).catch(() => running.delete(animation));
        });
      }, {threshold: .08});
      scope.querySelectorAll('[data-gq-reveal]').forEach(target => {
        if (target.getBoundingClientRect().top > window.innerHeight) reveal.observe(target);
      });
      cleanups.push(() => reveal.disconnect());
    }

    scope.querySelectorAll('[data-gq-gallery]').forEach(track => {
      const section = track.closest('.gq-lifestyle');
      const panels = Array.from(track.querySelectorAll('[data-gq-panel]'));
      const buttons = Array.from(section.querySelectorAll('[data-gq-gallery-index]'));
      let galleryFrame = 0;
      const update = () => {
        galleryFrame = 0;
        const trackRect = track.getBoundingClientRect();
        const center = trackRect.left + track.clientWidth / 2;
        const distances = panels.map(panel => Math.abs(panel.getBoundingClientRect().left + panel.clientWidth / 2 - center));
        const index = distances.indexOf(Math.min(...distances));
        buttons.forEach((button,i) => {
          if (i === index) button.setAttribute('aria-current','true');
          else button.removeAttribute('aria-current');
        });
      };
      buttons.forEach((button,index) => on(button,'click',() => {
        const panel = panels[index];
        if (!panel) return;
        const left = panel.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - (track.clientWidth - panel.clientWidth) / 2;
        track.scrollTo({left,behavior:canAnimate(track) ? 'smooth' : 'auto'});
      }));
      on(track,'scroll',() => { if (!galleryFrame) galleryFrame = requestAnimationFrame(update); },{passive:true});
      on(track,'keydown',event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        if (track.scrollWidth <= track.clientWidth) return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        track.scrollBy({left: direction * track.clientWidth * .88,behavior:canAnimate(track) ? 'smooth' : 'auto'});
      });
      cleanups.push(() => cancelAnimationFrame(galleryFrame));
    });

    sync();
  }

  function unmount(scope) {
    const state = controllers.get(scope);
    if (!state) return;
    state.controller.abort();
    state.cleanups.forEach(cleanup => cleanup());
    running.forEach(animation => {
      if (scope.contains(animation.effect?.target)) {
        animation.cancel();
        running.delete(animation);
      }
    });
    controllers.delete(scope);
  }

  document.querySelectorAll('#main > .shopify-section').forEach(mount);
  if (!controllers.size) mount(document);
  body.setAttribute('data-gq-enhanced','');
  window.addEventListener('scroll',queuePaint,{passive:true});
  window.addEventListener('resize',queuePaint,{passive:true});
  document.addEventListener('visibilitychange',() => {
    if (document.hidden) {
      running.forEach(animation => animation.finish());
      cancelAnimationFrame(frame);
      frame = 0;
    } else queuePaint();
  });
  reduced.addEventListener('change',sync);
  fine.addEventListener('change',sync);
  document.addEventListener('shopify:section:load',event => mount(event.target));
  document.addEventListener('shopify:section:unload',event => unmount(event.target));
  document.addEventListener('shopify:block:select',event => {
    running.forEach(animation => animation.finish());
    const panel = event.target.closest('[data-gq-panel]');
    if (panel) panel.scrollIntoView({block:'nearest',inline:'center',behavior:'auto'});
  });
  sync();
})();
  } catch(e) { console.error(e); }
})();

})();
